import { render, staticRenderFns } from "./RemoteCreate.vue?vue&type=template&id=f07f304e&scoped=true&"
import script from "./RemoteCreate.vue?vue&type=script&lang=js&"
export * from "./RemoteCreate.vue?vue&type=script&lang=js&"
import style0 from "./RemoteCreate.vue?vue&type=style&index=0&id=f07f304e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07f304e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
